
export enum GetAuctionStatesResponseDtoStatesItem {
  Pending= 'Pending',
  Running= 'Running',
  Expired= 'Expired',

}